import React  from 'react'
import {ChatEngine} from 'react-chat-engine';

const EngineChat = ({email, uid}: {email: string, uid: string}) => {

    return (
        <div style = {{marginTop: "66px"}}>
            <ChatEngine 
            height = {`calc(100vh - 66px)`}
            projectID = {process.env.REACT_APP_CHAT_ENGINE_ID}
            userName = {email}
            userSecret = {uid}
            />
        </div>
    )
}

export default EngineChat
